import { reactive, provide, inject } from 'vue';
import { PsProvider } from '../core/PsProvider';
import ProductParameterHolder from '@/object/holder/ProductParameterHolder';
import PsApiService from '@/api/PsApiService';
import Product from '@/object/Product'; 
import CategorywiseItem from '@/object/CategorywiseItem'; 
import PsResource from '@/api/common/PsResource';

export class RecentItemProvider extends PsProvider {

    itemList = reactive<PsResource<Product[]>>(new PsResource());
    categoryList = reactive<PsResource<CategorywiseItem[]>>(new PsResource());
    item = reactive<PsResource<Product>>(new PsResource());
    loading = reactive({
        value: false
    });

    limit: Number = 10;
    offset: Number = 0;
    isNoMoreRecord = reactive({
        value: false
    })

    id: string = "";
    paramHolder = reactive<ProductParameterHolder>(new ProductParameterHolder().getRecentParameterHolder());

    private updateProductList(responseData: PsResource<Product[]>) {

        if (this.itemList != null
            && this.itemList.data != null
            && this.itemList.data.length > 0
            && this.offset != 0) {

            if (responseData.data != null && responseData.data.length > 0) {
                this.itemList.data.push(...responseData.data);
            }else {
                this.isNoMoreRecord.value = true;
            }
            this.itemList.code = responseData.code;
            this.itemList.status = responseData.status;
            this.itemList.message = responseData.message;

        } else {

            this.itemList = responseData;


        }

        if (this.itemList != null && this.itemList.data != null) {
            this.offset = this.itemList.data.length;
        }

    }

    private updateCategoriesList(responseData: PsResource<CategorywiseItem[]>) {
        console.log('response data');
        console.log(responseData);
        if (this.categoryList != null
            && this.categoryList.data != null
            && this.categoryList.data.length > 0
            && this.offset != 0) {

            if (responseData.data != null && responseData.data.length > 0) {
                this.categoryList.data.push(...responseData.data);
            }else {
                this.isNoMoreRecord.value = true;
            }
            this.categoryList.code = responseData.code;
            this.categoryList.status = responseData.status;
            this.categoryList.message = responseData.message;

        } else {

            this.categoryList = responseData;


        }

        if (this.categoryList != null && this.categoryList.data != null) {
            this.offset = this.categoryList.data.length;
        }

    }

    async loadItemList(loginUserId:string,holder: ProductParameterHolder) {

        this.loading.value = true;

        // const responseData = await PsApiService.getItemListByUserId<Product>(new Product(), this.limit, this.offset, loginUserId, holder.toMap());
        const responseData = await PsApiService.getCategorywiseItem<CategorywiseItem>(new CategorywiseItem(), this.limit, this.offset, loginUserId, holder.toMap());
        console.log(responseData);
        // this.updateProductList(responseData);
        this.updateCategoriesList(responseData);

        this.loading.value = false;


    }


    async resetProductList(loginUserId:string,holder: ProductParameterHolder) {

        this.offset = 0;

        this.loading.value = true;

        // const responseData = await PsApiService.getItemListByUserId<Product>(new Product(), this.limit, this.offset, loginUserId, holder.toMap());
        const responseData = await PsApiService.getCategorywiseItem<CategorywiseItem>(new CategorywiseItem(), this.limit, this.offset, loginUserId, holder.toMap());

        // this.updateProductList(responseData);
        this.updateCategoriesList(responseData);

        this.loading.value = false;

    }

}

export const recentItemProviderSymbol = Symbol('RecentItemProvider')
export const createRecentItemProviderState = () => {
    return reactive(new RecentItemProvider())
}

export const useRecentItemProviderState = () => inject(recentItemProviderSymbol) as RecentItemProvider
export const provideRecentItemProviderState = () => provide(
    recentItemProviderSymbol,
    createRecentItemProviderState()
)